import React, { useContext, useState } from "react"
import { ThemedTextInput } from "./input/textinputs/themed-text-input"
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from "react-native"
import { ThemeContext } from "../utility/context/ThemeContext"
// import { COUNTRY_CODES } from "@ecountabl/lib"
import { textStyles } from "../style"

type Props = {
  inputRef?: React.RefObject<TextInput>
  value: { countryCode: string; phoneNumber: string}
  onChange: (code: string, value: string) => void
  placeholder?: string
  error?: string
  disabled?: boolean
}

const PhoneNumberInput: React.FC<Props> = ({
  inputRef, value, onChange, placeholder, error, disabled
}: Props) => {
  const theme = useContext(ThemeContext).theme
  const { borderColor, primary, textMain, bgMain } = theme.colors

  const [focused, setFocused] = useState<boolean>(false)

  // const countryCodes = useMemo(() => {
  //   return COUNTRY_CODES.sort((a, b) => {
  //     if (a.code === 'US') return -1
  //     if (b.code === 'US') return 1
  //     return 0
  //   }).map(code => ({
  //     label: `${code.code} ${code.dial_code}`,
  //     value: `${code.code} ${code.dial_code}`
  //   }))
  // },[])

  const beautifyPhoneNumber = (phone: string) => {
    if (!phone) return focused ? "|" : ""
    // grab first 3 digits or less and put in parentheses
    const cleaned = phone.replace(/\D/g, "")
    if (cleaned.length < 3) {
      return `(${cleaned}_)`
    }
    // grab next 3 digits and put a space after
    const firstPart = cleaned.slice(0, 3)
    const secondPart = cleaned.slice(3, 6)
    const thirdPart = cleaned.slice(6, 10)
    const fourthPart = cleaned.slice(10, 15)
    
    // Check if there's room for more digits
    const hasRoomForMore = cleaned.length < 15

    return `(${firstPart}) ${secondPart} ${thirdPart}${fourthPart ? `-${fourthPart}` : ""}${hasRoomForMore ? "_" : ""}`
  }

  return (
    <View style={{}}>
      <View style={{flexDirection: "row", width: "100%"}}>
        <TextInput
          ref={inputRef}
          value={value.phoneNumber}
          onChangeText={(text) => {
            // clean text to where it is only digits to prevent sync issues
            const cleanedText = text.replace(/\D/g, "")
            onChange(value.countryCode, cleanedText)
          }}
          maxLength={15}
          keyboardType="number-pad"
          inputMode="numeric"
          textContentType="telephoneNumber"
          autoComplete="tel"
          autoCorrect={false}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            opacity: 0,
            width: 0
          }}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          editable={!disabled}
        />
        <View style={[
          styles.countryCodeSelectContainer
        ]}>
          {/* 
            // this component would support international phone #s
            // but we don't have a need to support them yet. strictyl US for now
            <BoxedDropdown
            value={value?.countryCode}
            onChange={(t) => onChange(t, value?.phoneNumber)}
            placeholder="Country Code"
            data={countryCodes}
            displayTextField="label"
            valueField="value"
            inputStyle={{
              ...styles.countryCodeSelect,
              height: 42
            }}
            onFocus={() => {
              inputRef?.current?.blur()
            }}
          /> */}
          <View
            style={{
              height: 42,
              width: "100%",
              borderWidth: 1,
              borderColor: borderColor,
              borderTopLeftRadius: 8,
              borderBottomLeftRadius: 8,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: bgMain
            }}
          >
            <Text style={{
              ...textStyles.h4,
              color: textMain,
              fontWeight: "bold"
            }}>
              {value.countryCode}
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={() => inputRef?.current?.focus()}
          style={{pointerEvents: "box-only", flex: 1}}
          activeOpacity={1}
        >
          <ThemedTextInput
            value={beautifyPhoneNumber(value?.phoneNumber)}
            onChange={undefined}
            placeholder={placeholder || "Phone Number"}
            textInputProps={{
              style: {
                borderColor: focused ? primary : borderColor,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                width: "100%",
                backgroundColor: bgMain
              },
              caretHidden: true
            }}
          />
        </TouchableOpacity>
      </View>
      { error ? (
        <Text style={[textStyles.subscript, {color: theme.colors.danger, marginTop: 5}]}>
          {error}
        </Text>
      ) : null}
    </View>
  )
}

export default PhoneNumberInput

const styles = StyleSheet.create({
  countryCodeSelectContainer: {
    width: 120,
    height: 42
  },
  countryCodeSelect: {
    height: "100%",
    width: "100%",
    borderWidth: 1,
    borderBottomLeftRadius: 8,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  }
})